import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { FlexModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";

import { mdiCheck } from "@mdi/js";

import { DffFormControlModule } from "@dffedb/forms";
import {
    DffButtonModule,
    DffDateFieldModule,
    DffEmailFieldModule,
    DffInfoModule,
    DffKvitteringModule,
    DffSideModule,
    ErrorModule,
    PanelModule,
    SpinnerModule
} from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";
import { MaalerAflaesningModule } from "@e-forsyning/common/maaler";

import { FeatureMaalerAflaesningRoutingModule } from "./feature-maaler-aflaesning-routing.module";
import { FeatureMaalerAflaesningComponent } from "./feature-maaler-aflaesning.component";
import { MaalerAflaesningKvitteringComponent } from "./maaler-aflaesning-kvittering/maaler-aflaesning-kvittering.component";

@NgModule({
    imports: [
        CommonModule,
        FeatureMaalerAflaesningRoutingModule,
        MaalerAflaesningModule,
        DffButtonModule,
        DffEmailFieldModule,
        DffFormControlModule,
        DffDateFieldModule,
        DffInfoModule,
        DffKvitteringModule,
        DffSideModule,
        ErrorModule,
        MatExpansionModule,
        MatIconModule,
        MatStepperModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatTableModule,
        PanelModule,
        ReactiveFormsModule,
        SpinnerModule
    ],
    declarations: [FeatureMaalerAflaesningComponent, MaalerAflaesningKvitteringComponent],
    providers: []
})
export class EForsyningFeaturesMaalerAflaesningModule {
    constructor(iconRegistry: SvgIconRegistry) {
        iconRegistry.registerIcon(mdiCheck, "check");
    }
}
